import { Box, Text, Badge, VStack } from '@chakra-ui/react';
import type { GuidedListSpec } from '../../../types/guidedList'

interface StepProps { spec: GuidedListSpec; patch: (p: Partial<GuidedListSpec>) => void }

export function ContestStep(_props: StepProps) {
  // v0 is primary-only; the general-race branch slots in here later (spec §9).
  return (
    <VStack align="stretch" gap={3}>
      <Text fontWeight="semibold">What kind of race?</Text>
      <Box borderWidth="1px" borderRadius="md" p={4} bg="info.subtle">
        <Badge bg="info.subtle" color="info.fg" mb={1}>Primary</Badge>
        <Text fontSize="sm" color="gray.700">
          You’re building a universe for a partisan primary. (General-race support is coming later.)
        </Text>
      </Box>
    </VStack>
  );
}
